// extracted by mini-css-extract-plugin
module.exports = {"inlineButton":"ResidentList_inlineButton__24rmu","mediRow":"ResidentList_mediRow__3mGBV","modalContent":"ResidentList_modalContent__2d2I7"};